import React, { useState, useEffect } from "react";
import type { FC, PropsWithChildren } from "react";
import style from "../../styles/Patient.module.css";
import Rtmplanstyle from "../../styles/RtmPlan.module.css";
import PatientStyle from "../../styles/Patient.module.css";
import {
  InputsSection,
  InputBox,
  ModalForm,
  Modal,
  SelectBox,
} from "../../../src/components/Modal";
import { Button } from "../../components/Modal";

import AddPlanSkeleton from "../../Skeletons/AddPlanSkeleton";
import ModalHeading from "../../../src/components/Modal/ModalHeading";
import TextBox from "../../../src/components/Modal/InputBox/TextBox.module.css";

import useAllTemplate from "../../hooks/rtm_plan/useAllTemplates";
import useAllIntakeForms from "../../hooks/rtm_plan/useAllIntakeForms";
import { IRTMPlan } from "../../hooks/rtm_plan/index.type";
import useTimeZone from "../../hooks/rtm_plan/useTimeZone";

export type AddEditModalState = PropsWithChildren<{
  status: boolean;
  data?: IRTMPlan;
}>;

export interface ICommonState {
  key: string;
  value: string;
}

export type IaddEditModalStates = PropsWithChildren<{
  name: { value: string; error: string };
  // templateIds: { value: string[]; error: string };
  templateIds: { value: string; error: string };
  type: { value: string; error: string };
  billingCycle: { value: string; error: string };
  frequency: { value: string; error: string };
  custom?: { value: string; error: string };
  timezone: { value: string; error: string };
  time: { value: string; error: string };
  isContinueuseBilling: boolean;
  intakeFormId: { value: string; error: string };
}>;

type AddEditModalProps = PropsWithChildren<{
  loading: boolean;
  addEditModal: AddEditModalState;
  onCloseModal?: () => void;
  handleAddEdit?: (event: React.FormEvent<HTMLFormElement>) => void;
  addEditModalStates: IaddEditModalStates;
  setAddEditModalStates: React.Dispatch<
    React.SetStateAction<IaddEditModalStates>
  >;

  billingCycle: ICommonState[];
  frequency: ICommonState[];
  billingCycleLoading: boolean;
  frequencyLoading: boolean;
  processType: ICommonState[];
  processTypeLoading: boolean;
}>;
const AddEditModal: FC<AddEditModalProps> = (props) => {
  const { TemplateDataLoading, getTemplateData, TemplateData } =
    useAllTemplate();
  const { intakeFormsLoading, getIntakeFormsData, intakeForms } =
    useAllIntakeForms();

  const { timeZone, timeZoneLoading, getTimeZone } = useTimeZone();
  useEffect(() => {
    getTemplateData();
    getIntakeFormsData();
    getTimeZone();
  }, []);

  // Common styles for form elements
  const formElementStyles = {
    inputContainerStyle: {
      width: "100%",
      boxShadow: "none",
      borderRadius: "8px",
      border: "1px solid #D1D5DB",
      paddingTop: "1rem",
      height: "4rem",
      color: "#000000",
      fontWeight: "300",
    },
    style: { width: "100%", fontSize: "1.6rem" },
  };

  return (
    <Modal
      show={props.addEditModal.status}
      modalClassName={Rtmplanstyle.customAddModal}
    >
      <ModalHeading
        heading={
          props.addEditModal.data && props.addEditModal.data._id
            ? "Update Plan"
            : "Add Plan"
        }
        customClass={Rtmplanstyle.customModalHeading}
        customCloseClass={style.close_btn}
        closeIcon="close-cross"
        onClose={props.onCloseModal}
      />
      {/* {props.loading ? (
        <AddPlanSkeleton />
      ) : ( */}
      <ModalForm
        customClass={Rtmplanstyle.customForm}
        style={{ marginBottom: "2rem" }}
        onSubmit={props.handleAddEdit}
      >
        {/* Plan Name */}
        <div className={Rtmplanstyle.input_container}>
          <InputsSection customClass={Rtmplanstyle.input_section}>
            <InputBox
              label="Plan Name"
              placeholder="Enter plan name"
              value={props.addEditModalStates.name.value}
              onChange={(event) => {
                props.setAddEditModalStates((prevVal) => ({
                  ...prevVal,
                  name: { value: event.target.value, error: "" },
                }));
              }}
              errorMessage={props.addEditModalStates.name.error}
              {...formElementStyles}
              className={Rtmplanstyle.container_style}
              labelClass={Rtmplanstyle.label_style}
              inputContainerClass={Rtmplanstyle.input_container_style}
              style={{ color: "black", fontSize: "1.6rem" }}
            />
          </InputsSection>

          {/* Template - Multiple Select */}
          <InputsSection customClass={Rtmplanstyle.name_input_section}>
            <SelectBox
              label="Template"
              value={props.addEditModalStates.templateIds.value}
              onChange={(event) => {
                props.setAddEditModalStates((prevVal) => ({
                  ...prevVal,
                  templateIds: { value: event.target.value, error: "" },
                }));
              }}
              errorMessage={props.addEditModalStates.templateIds.error}
              {...formElementStyles}
              containerClass={Rtmplanstyle.container_style}
              labelClass={Rtmplanstyle.label_style}
              inputContainerClass={Rtmplanstyle.input_container_style}
              inputClass={Rtmplanstyle.full_width}
              isDisabled={!!props.addEditModal?.data?._id}
            >
              <option value="">Select care template</option>
              {TemplateDataLoading ? (
                <option>Loading...</option>
              ) : (
                <>
                  {TemplateData?.map((template) => (
                    <option key={template._id} value={template._id}>
                      {template.name}
                    </option>
                  ))}
                </>
              )}
            </SelectBox>

            <SelectBox
              label="Intake Form"
              value={props.addEditModalStates.intakeFormId.value}
              onChange={(event) => {
                props.setAddEditModalStates((prevVal) => ({
                  ...prevVal,
                  intakeFormId: { value: event.target.value, error: "" },
                }));
              }}
              errorMessage={props.addEditModalStates.intakeFormId.error}
              {...formElementStyles}
              containerClass={Rtmplanstyle.container_style}
              labelClass={Rtmplanstyle.label_style}
              inputContainerClass={Rtmplanstyle.input_container_style}
              inputClass={Rtmplanstyle.full_width}
              isDisabled={!!props.addEditModal?.data?._id}
            >
              <option value="" disabled>
                Select intake form
              </option>
              {intakeFormsLoading ? (
                <option>Loading...</option>
              ) : (
                <>
                  {intakeForms.map((form) => (
                    <option key={form._id} value={form._id}>
                      {form.name}
                    </option>
                  ))}
                </>
              )}
            </SelectBox>
          </InputsSection>

          {/* Text Message Process (SMS Send Type) */}
          <InputsSection customClass={Rtmplanstyle.name_input_section}>
            <SelectBox
              label="Text Message Process"
              value={props.addEditModalStates.type.value}
              onChange={(event) => {
                props.setAddEditModalStates((prevVal) => ({
                  ...prevVal,
                  type: { value: event.target.value, error: "" },
                }));
              }}
              errorMessage={props.addEditModalStates.type.error}
              containerClass={Rtmplanstyle.container_style}
              labelClass={Rtmplanstyle.label_style}
              inputContainerClass={Rtmplanstyle.input_container_style}
              inputClass={Rtmplanstyle.full_width}
              {...formElementStyles}
              isDisabled={!!props.addEditModal?.data?._id}
            >
              <option value="">Text Message Process</option>
              {props.processTypeLoading ? (
                <option disabled>Loading...</option>
              ) : (
                props.processType.map((freq) => (
                  <option key={freq.key} value={freq.key}>
                    {freq.value}
                  </option>
                ))
              )}
            </SelectBox>
            <SelectBox
              label="Text Message Frequency"
              value={props.addEditModalStates.frequency.value}
              onChange={(event) => {
                props.setAddEditModalStates((prevVal) => ({
                  ...prevVal,
                  frequency: { value: event.target.value, error: "" },
                }));
              }}
              errorMessage={props.addEditModalStates.frequency.error}
              containerClass={Rtmplanstyle.container_style}
              labelClass={Rtmplanstyle.label_style}
              inputContainerClass={Rtmplanstyle.input_container_style}
              inputClass={Rtmplanstyle.full_width}
              {...formElementStyles}
              isDisabled={!!props.addEditModal?.data?._id}
            >
              <option value="">Text Message Frequency</option>
              {props.frequencyLoading ? (
                <option>Loading...</option>
              ) : (
                <>
                  {props.frequency.map((freq) => (
                    <option key={freq.key} value={freq.key}>
                      {freq.value}
                    </option>
                  ))}
                </>
              )}
            </SelectBox>
          </InputsSection>

          {/* Text Message Frequency */}
          <InputsSection customClass={Rtmplanstyle.name_input_section}>
            <SelectBox
              label="Time Zone"
              value={props.addEditModalStates.timezone.value}
              onChange={(event) => {
                props.setAddEditModalStates((prevVal) => ({
                  ...prevVal,
                  timezone: { value: event.target.value, error: "" },
                }));
              }}
              errorMessage={props.addEditModalStates.timezone.error}
              containerClass={Rtmplanstyle.container_style}
              labelClass={Rtmplanstyle.label_style}
              inputContainerClass={Rtmplanstyle.input_container_style}
              inputClass={Rtmplanstyle.full_width}
              {...formElementStyles}
            >
              <option value="">Time Zone</option>
              {timeZoneLoading ? (
                <option>Loading...</option>
              ) : (
                <>
                  {timeZone.map((time) => (
                    <option key={time.key} value={time.key}>
                      {time.value}
                    </option>
                  ))}
                </>
              )}
            </SelectBox>
            <InputBox
              label=" Text Message Time"
              placeholder=""
              type="time"
              value={props.addEditModalStates.time.value}
              onChange={(event) => {
                let timeValue = event.target.value;
                if (timeValue && !timeValue.endsWith(":00")) {
                  if (timeValue.includes(":")) {
                    timeValue = timeValue.split(":")[0] + ":00";
                  } else {
                    timeValue = timeValue + ":00";
                  }
                }
                props.setAddEditModalStates((prevVal) => ({
                  ...prevVal,
                  time: { value: timeValue, error: "" },
                }));
              }}
              errorMessage={props.addEditModalStates.time.error}
              className={Rtmplanstyle.container_style}
              labelClass={Rtmplanstyle.label_style}
              inputContainerClass={Rtmplanstyle.input_container_style}
              {...formElementStyles}
              style={{ color: "black", fontSize: "1.6rem" }}
            />
          </InputsSection>
          {/* Billing Cycle */}
          <InputsSection customClass={Rtmplanstyle.name_input_section}>
            <SelectBox
              label="Billing Cycle"
              value={props.addEditModalStates.billingCycle.value}
              onChange={(event) => {
                props.setAddEditModalStates((prevVal) => ({
                  ...prevVal,
                  billingCycle: { value: event.target.value, error: "" },
                }));
              }}
              errorMessage={props.addEditModalStates.billingCycle.error}
              {...formElementStyles}
              containerClass={Rtmplanstyle.container_style}
              labelClass={Rtmplanstyle.label_style}
              inputContainerClass={Rtmplanstyle.input_container_style}
              inputClass={Rtmplanstyle.full_width}
              isDisabled={!!props.addEditModal?.data?._id}
            >
              <option value="">Billing Cycle</option>
              {props.frequencyLoading ? (
                <option>Loading...</option>
              ) : (
                <>
                  {props.billingCycle.map((cycle) => (
                    <option key={cycle.key} value={cycle.key}>
                      {cycle.value}
                    </option>
                  ))}
                </>
              )}
            </SelectBox>
            <div
              style={{ marginLeft: "1rem" }}
              className={`${TextBox.form_input} ${Rtmplanstyle.container_style}`}
            >
              <label
                className={`${TextBox.form_input__label} ${Rtmplanstyle.label_style}`}
              >
                Continuous Billing
              </label>
              <div
                style={{
                  display: "flex",
                  gap: "2rem",
                  marginTop: "0.1rem",
                  padding: "0.5rem 0",
                }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#374151",
                  }}
                >
                  <input
                    type="radio"
                    name="continuousBilling"
                    checked={
                      props.addEditModalStates.isContinueuseBilling === true
                    }
                    onChange={() =>
                      props.setAddEditModalStates((prevVal) => ({
                        ...prevVal,
                        isContinueuseBilling: true,
                      }))
                    }
                  />
                  Yes
                </label>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    fontSize: "1.4rem",
                    color: "#374151",
                  }}
                >
                  <input
                    type="radio"
                    name="continuousBilling"
                    checked={
                      props.addEditModalStates.isContinueuseBilling === false
                    }
                    onChange={() =>
                      props.setAddEditModalStates((prevVal) => ({
                        ...prevVal,
                        isContinueuseBilling: false,
                      }))
                    }
                  />
                  No
                </label>
              </div>
            </div>
          </InputsSection>
        </div>
        {/* buttons  */}
        <div className={Rtmplanstyle.enroll_btn_container}>
          <Button
            label="Cancel"
            span={false}
            onClick={props.onCloseModal}
            submitButtonStyle={{
              background: "#E5E7EB",
              color: "#374151",
              border: "1px solid #D1D5DB",
              borderRadius: "8px",
            }}
          />
          <Button
            type="submit"
            label={
              props.loading
                ? props.addEditModal.data?._id
                  ? "Saving..."
                  : "Creating..."
                : props.addEditModal.data?._id
                ? "Save Plan"
                : "Create Plan"
            }
            disabled={props.loading}
            span={false}
            submitButtonStyle={{
              background: props.loading ? "var(--grey)" : "#2563EB", 
              border: "none",
              color: "#fff",
              borderRadius: "8px",
              cursor: props.loading ? "not-allowed" : "pointer",
              // opacity: props.loading ? 0.7 : 1, 
            }}
          />
        </div>
      </ModalForm>
      {/* )} */}
    </Modal>
  );
};

export default AddEditModal;
